import { render, staticRenderFns } from "./oldCare.vue?vue&type=template&id=6ecb1bdb&"
import script from "./oldCare.vue?vue&type=script&lang=js&"
export * from "./oldCare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports